import { CulturePreset, CulturePresetModule_toInt, EventType, EventTypeModule_toInt, CulturePresetModule_fromInt, EventTypeModule_fromInt } from "../Shared/Types.js";
import { formatDate, t } from "../Lang.js";
import { Event_noEvents, Event_new, Event_pageTitle, Common_delete, Event_confirmYes, Event_confirmDelete, Common_cancel, Event_createButton, Event_creating, Event_date, Event_culture, Event_type, Event_namePlaceholder, Event_name, Enum_Culture_international, Enum_Culture_custom, Enum_Culture_american, Enum_Culture_british, Enum_Culture_chinese, Enum_Culture_french, Enum_Culture_swedish, Enum_Eventtype_formaldinner, Enum_Eventtype_custom, Enum_Eventtype_casual, Enum_Eventtype_corporate, Enum_Eventtype_banquet, Enum_Eventtype_wedding } from "../Shared/Tr.js";
import { singleton as singleton_1, isEmpty, ofArray, map } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { createElement } from "react";
import { equals, int32ToString, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { Msg } from "../App/Messages.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tryParse } from "../fable_modules/fable-library-js.4.28.0/Int32.js";
import { FSharpRef } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { empty, append, singleton, collect, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { Page, EventTab } from "../Router.js";
import { PropHelpers_createOnKey } from "../fable_modules/Feliz.2.9.0/Properties.fs.js";
import { key_escape } from "../fable_modules/Feliz.2.9.0/Key.fs.js";
import { AdSlot } from "./AdSlot.js";

function eventTypeName(et) {
    const matchValue = EventTypeModule_fromInt(et);
    switch (matchValue.tag) {
        case 1:
            return t(Enum_Eventtype_wedding);
        case 2:
            return t(Enum_Eventtype_banquet);
        case 3:
            return t(Enum_Eventtype_corporate);
        case 4:
            return t(Enum_Eventtype_casual);
        case 5:
            return t(Enum_Eventtype_custom);
        default:
            return t(Enum_Eventtype_formaldinner);
    }
}

function culturePresetName(cp) {
    const matchValue = CulturePresetModule_fromInt(cp);
    switch (matchValue.tag) {
        case 1:
            return t(Enum_Culture_swedish);
        case 2:
            return t(Enum_Culture_french);
        case 3:
            return t(Enum_Culture_chinese);
        case 4:
            return t(Enum_Culture_british);
        case 5:
            return t(Enum_Culture_american);
        case 6:
            return t(Enum_Culture_custom);
        default:
            return t(Enum_Culture_international);
    }
}

function eventTypeOptions() {
    return map((et) => [EventTypeModule_toInt(et), eventTypeName(EventTypeModule_toInt(et))], ofArray([new EventType(0, []), new EventType(1, []), new EventType(2, []), new EventType(3, []), new EventType(4, []), new EventType(5, [])]));
}

function culturePresetOptions() {
    return map((cp) => [CulturePresetModule_toInt(cp), culturePresetName(CulturePresetModule_toInt(cp))], ofArray([new CulturePreset(0, []), new CulturePreset(1, []), new CulturePreset(2, []), new CulturePreset(3, []), new CulturePreset(4, []), new CulturePreset(5, []), new CulturePreset(6, [])]));
}

function newEventForm(form, dispatch) {
    let elems_9, elems_3, elems, elems_2, elems_1, elems_7, elems_5, elems_4, elems_6, elems_8;
    return createElement("div", createObj(ofArray([["className", "new-event-form"], (elems_9 = [createElement("div", createObj(ofArray([["className", "form-row"], (elems_3 = [createElement("div", createObj(ofArray([["className", "form-group"], (elems = [createElement("label", {
        children: t(Event_name),
    }), createElement("input", {
        className: "form-input",
        type: "text",
        placeholder: t(Event_namePlaceholder),
        value: form.Name,
        onChange: (ev) => {
            dispatch(new Msg(41, [ev.target.value]));
        },
        disabled: form.IsSubmitting,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("label", {
        children: t(Event_type),
    }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", int32ToString(form.EventType)], ["onChange", (ev_1) => {
        let matchValue;
        let outArg = 0;
        matchValue = [tryParse(ev_1.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_2) => {
            outArg = (v_2 | 0);
        })), outArg];
        if (matchValue[0]) {
            dispatch(new Msg(42, [matchValue[1]]));
        }
    }], ["disabled", form.IsSubmitting], (elems_1 = toList(delay(() => collect((matchValue_1) => singleton(createElement("option", {
        value: int32ToString(matchValue_1[0]),
        children: matchValue_1[1],
    })), eventTypeOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["className", "form-row"], (elems_7 = [createElement("div", createObj(ofArray([["className", "form-group"], (elems_5 = [createElement("label", {
        children: t(Event_culture),
    }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", int32ToString(form.CulturePreset)], ["onChange", (ev_2) => {
        let matchValue_2;
        let outArg_1 = 0;
        matchValue_2 = [tryParse(ev_2.target.value, 511, false, 32, new FSharpRef(() => outArg_1, (v_4) => {
            outArg_1 = (v_4 | 0);
        })), outArg_1];
        if (matchValue_2[0]) {
            dispatch(new Msg(43, [matchValue_2[1]]));
        }
    }], ["disabled", form.IsSubmitting], (elems_4 = toList(delay(() => collect((matchValue_3) => singleton(createElement("option", {
        value: int32ToString(matchValue_3[0]),
        children: matchValue_3[1],
    })), culturePresetOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_6 = [createElement("label", {
        children: t(Event_date),
    }), createElement("input", {
        className: "form-input",
        type: "date",
        value: form.Date,
        onChange: (ev_3) => {
            dispatch(new Msg(44, [ev_3.target.value]));
        },
        disabled: form.IsSubmitting,
    })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", createObj(ofArray([["className", "flex gap-sm mt-1"], (elems_8 = [createElement("button", {
        className: "btn btn-primary",
        children: form.IsSubmitting ? t(Event_creating) : t(Event_createButton),
        disabled: form.IsSubmitting ? true : (form.Name.trim() === ""),
        onClick: (_arg) => {
            if (!form.IsSubmitting) {
                dispatch(new Msg(35, []));
            }
        },
    }), createElement("button", {
        className: "btn btn-secondary",
        children: t(Common_cancel),
        onClick: (_arg_1) => {
            dispatch(new Msg(45, []));
        },
        disabled: form.IsSubmitting,
    })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
}

function eventCard(event, isConfirming, dispatch) {
    let elems_2, elems, elems_1;
    return createElement("div", createObj(ofArray([["className", "card card-clickable"], ["onClick", (_arg) => {
        if (!isConfirming) {
            dispatch(new Msg(0, [new Page(6, [event.Id, new EventTab(0, [])])]));
        }
    }], (elems_2 = [createElement("h3", {
        children: event.Name,
    }), createElement("div", createObj(ofArray([["className", "card-meta"], (elems = toList(delay(() => append(singleton(createElement("span", {
        children: eventTypeName(event.EventType),
    })), delay(() => append(singleton(createElement("span", {
        children: culturePresetName(event.CulturePreset),
    })), delay(() => {
        const matchValue = event.Date;
        if (matchValue == null) {
            return empty();
        }
        else {
            return singleton(createElement("span", {
                children: formatDate(matchValue),
            }));
        }
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "card-actions"], (elems_1 = toList(delay(() => (isConfirming ? append(singleton(createElement("span", {
        className: "text-muted",
        children: t(Event_confirmDelete),
    })), delay(() => append(singleton(createElement("button", {
        className: "btn btn-sm btn-danger",
        children: t(Event_confirmYes),
        onClick: (e) => {
            e.stopPropagation();
            dispatch(new Msg(39, [event.Id]));
        },
    })), delay(() => singleton(createElement("button", {
        className: "btn btn-sm btn-secondary",
        children: t(Common_cancel),
        autoFocus: true,
        onKeyDown: (ev) => {
            PropHelpers_createOnKey(key_escape, (e_1) => {
                e_1.stopPropagation();
                dispatch(new Msg(38, []));
            }, ev);
        },
        onClick: (e_2) => {
            e_2.stopPropagation();
            dispatch(new Msg(38, []));
        },
    })))))) : singleton(createElement("button", {
        className: "btn btn-sm btn-danger",
        children: t(Common_delete),
        onClick: (e_3) => {
            e_3.stopPropagation();
            dispatch(new Msg(37, [event.Id]));
        },
    }))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function view(model, dispatch) {
    let elems_3;
    return createElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "page-header"], (elems = toList(delay(() => append(singleton(createElement("h2", {
            children: t(Event_pageTitle),
        })), delay(() => (!model.NewEventForm.IsVisible ? singleton(createElement("button", {
            className: "btn btn-primary",
            children: t(Event_new),
            onClick: (_arg) => {
                dispatch(new Msg(45, []));
            },
        })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let matchValue;
            return append((matchValue = model.Error, (matchValue == null) ? (empty()) : singleton(createElement("div", {
                className: "error-message",
                children: matchValue,
            }))), delay(() => append(model.NewEventForm.IsVisible ? singleton(newEventForm(model.NewEventForm, dispatch)) : empty(), delay(() => append(singleton(createElement(AdSlot, {
                adSlotId: "XXXXXXXXXX",
                adFormat: "auto",
                cssClass: "ad-slot-eventlist",
            })), delay(() => {
                let elems_1, elems_2;
                return isEmpty(model.Events) ? singleton(createElement("div", createObj(ofArray([["className", "card"], (elems_1 = [createElement("p", {
                    className: "text-muted",
                    children: t(Event_noEvents),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : singleton(createElement("div", createObj(ofArray([["className", "event-grid"], (elems_2 = toList(delay(() => collect((event) => singleton(eventCard(event, equals(model.DeleteEventConfirm, event.Id), dispatch)), model.Events))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }))))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))));
}

